/**
 * Firestore Collections
 * Centralized collection names for AllTuc
 */

export const COLLECTIONS = {
  // Users & Auth
  USERS: 'users',
  PARTNERS: 'partners',
  SHOPS: 'shops',
  SHOP_FOLLOWERS: 'shopFollowers',

  // Products & Catalog
  PRODUCTS: 'products',
  CATEGORIES: 'categories',
  REVIEWS: 'reviews',
  PRODUCT_REVIEWS: 'productReviews',
  SHOP_REVIEWS: 'shopReviews',
  QUESTIONS: 'questions',
  QUESTION_REPORTS: 'questionReports',

  // Orders & Commerce
  ORDERS: 'orders',
  TRANSACTIONS: 'transactions',
  CART: 'cart',

  // Services & Bookings
  SERVICES: 'services',
  BOOKINGS: 'bookings',

  // Marketing & Content
  BANNERS: 'banners',
  BLOG_POSTS: 'blogPosts',
  STORIES: 'stories',
  MARKETING_CAMPAIGNS: 'marketingCampaigns',

  // Social & Community
  NOTIFICATIONS: 'notifications',
  CHATS: 'chats',
  SUPPORT_TICKETS: 'support_tickets',
  FAVORITES: 'favorites',

  // Partner specific
  PARTNER_NOTIFICATIONS: 'partnerNotifications',
  
  // Wallet & Finance
  WALLET: 'wallet',
  WALLET_HISTORY: 'walletHistory',
  WITHDRAWALS: 'withdrawals',

  // Gamification
  CLUB_MEMBERS: 'clubMembers',
  TUC_COINS: 'tucCoins',

  // Analytics
  ANALYTICS_EVENTS: 'analyticsEvents',
  PAGE_VIEWS: 'pageViews',

  // System
  SETTINGS: 'settings',
  AUDIT_LOGS: 'auditLogs',
  CONFIG: 'config',
} as const;

export type CollectionName = typeof COLLECTIONS[keyof typeof COLLECTIONS];

// Subcollections
export const SUBCOLLECTIONS = {
  CHAT_MESSAGES: (userId: string) => `chats/${userId}/messages`,
  ORDER_ITEMS: (orderId: string) => `orders/${orderId}/items`,
  SHOP_PRODUCTS: (shopId: string) => `shops/${shopId}/products`,
} as const;

// Collection groups (for queries across subcollections)
export const COLLECTION_GROUPS = {
  ALL_PRODUCTS: 'allProducts',
  ALL_REVIEWS: 'allReviews',
  ALL_BOOKINGS: 'allBookings',
} as const;
